module.exports = __webpack_public_path__ + "static/media/fog.7649ecc3.png";